<template>
  <path
    d="M14.29 5.71022C13.9 6.10022 13.9 6.73022 14.29 7.12022L18.17 11.0002H3C2.45 11.0002 2 11.4502 2 12.0002C2 12.5502 2.45 13.0002 3 13.0002H18.18L14.3 16.8802C13.91 17.2702 13.91 17.9002 14.3 18.2902C14.69 18.6802 15.32 18.6802 15.71 18.2902L21.3 12.7002C21.69 12.3102 21.69 11.6802 21.3 11.2902L15.7 5.71022C15.32 5.32022 14.68 5.32022 14.29 5.71022Z"
  />
</template>
